import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getLastUrl, getUser, isAuthenticated, signIn } from "../../auth/Auth";
import { useTranslation } from "react-i18next";

import img from "../../assets/images/review/google.png";
import imgMI from "../../assets/images/media-intelligence-icon.png";
import { connection, generateOtp } from "../../services/AuthServices";
import { testUrlValid } from "../../Constants";
import ReactLoading from "react-loading";

function SignIn() {
  const [showPass, setShowPass] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const loginUser = async (e) => {
    e.preventDefault();

    const notify = (message, type) => toast[type](message);

    if (email.trim() === "" || password.trim() === "") {
      notify(t("Notifications.error.errorInfoRequired"), "error");
      return;
    }

    setIsLoading(true);

    try {
      const data = {
        email,
        password,
        remember: true,
      };

      const lastUrl = getLastUrl();
      const response = await connection(data);

      localStorage.setItem("temp_email", email);

      if (response.data.data.user.is_first_connection === 1) {
        navigate("/reset-password");
        return;
      }

      // Store data in localStorage
      signIn(response.data);

      // Handle redirection with OTP if URL is valid
      if (testUrlValid(lastUrl)) {
        const res = await generateOtp(getUser().id);
        const otp = res.data.otp.otp;

        if (otp) {
          toast.success(
            "Success! Your OTP has been sent to your email. Please check your email"
          );
          window.location.replace(`${lastUrl}?otp=${otp}`);
        }
      }
    } catch (error) {
      if (error.status === 400) {
        notify(error.data.message, "error");
      }
      // Other error cases handled silently to reduce console noise
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const handleRedirect = async () => {
      const lastUrl = getLastUrl();

      if (testUrlValid(lastUrl) && isAuthenticated()) {
        try {
          const response = await generateOtp(getUser().id);
          const otp = response.data.otp.otp;

          if (otp) {
            window.location.replace(`${lastUrl}?otp=${otp}`);
          }
        } catch (error) {
          // Silent error handling to prevent console errors
        }
      }
    };

    handleRedirect();
  }, []);

  return (
    <section className="account-section">
      <div className="tf-container">
        <div className="row">
          <ToastContainer />

          <div className="wd-form-login">
            <a
              href={process.env.REACT_APP_CLIENT_SERVICE}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={imgMI} className="mb-4" alt="logo" />
            </a>
            <h4>{t("signin.identify")}</h4>

            <form onSubmit={loginUser}>
              <div className="ip">
                <label>
                  {t("signin.email")}
                  <span>*</span>
                </label>
                <input
                  type="email"
                  placeholder={t("signin.emailPlaceholder")}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="ip">
                <label>
                  {t("signin.passwordPlaceholder")}
                  <span>*</span>
                </label>
                <div className="inputs-group auth-pass-inputgroup">
                  <input
                    type={showPass ? "text" : "password"}
                    className="input-form password-input"
                    placeholder={t("signin.passwordPlaceholder")}
                    id="password-input"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <Link
                    to="#"
                    className={`password-addon ${
                      showPass ? "icon-eye" : "icon-eye-off"
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      setShowPass(!showPass);
                    }}
                  />
                </div>
              </div>

              <div className="group-ant-choice">
                <div className="sub-ip">
                  <input type="checkbox" id="remember-me" />
                  <label htmlFor="remember-me">{t("signin.rememberMe")}</label>
                </div>
                <Link to="/forgot-password" className="forgot">
                  {t("signin.passwordForgot")}
                </Link>
              </div>

              <div className="group-ant-choice st">
                <button
                  type="submit"
                  disabled={isLoading}
                  className="login-button"
                >
                  {isLoading ? (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        width: "100%",
                      }}
                    >
                      <ReactLoading
                        type="spin"
                        color="white"
                        height={30}
                        width={30}
                      />
                      {t("signin.loading")}
                    </span>
                  ) : (
                    t("signin.connexion")
                  )}
                </button>
              </div>

              <p className="line-ip">
                <span>{t("signin.connexionSuggest")}</span>
              </p>

              <Link
                to={`${process.env.REACT_APP_BACKEND_SERVICE}/auth/redirect`}
                className="btn-social"
              >
                <img src={img} alt="Google sign-in" />
                {t("signin.googleConnect")}
              </Link>

              <div className="sign-up">
                {t("signin.NoAccount")}{" "}
                <Link to="/register">{t("signin.register")}</Link>
                <br />
                <br />
                <Link
                  to={process.env.REACT_APP_CLIENT_SERVICE}
                  className="btn-social"
                >
                  {t("signin.siteWeb")}
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SignIn;
